<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 5, 18, 5]">
        <v-tooltip />
        <v-bar :position="'x*'+yTitle" />
      </v-chart>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  const tooltip = [
    'x*y',
    (x, yy) => ({
      name: x,
      value: y
    })
  ]

  const scale = [{
    dataKey: 'x',
    min: 2
  }, {
    dataKey: 'y',
    title: '时间',
    min: 1,
    max: 30
  }]

  export default {
    name: 'MiniBar',
    props: {
      data:{
        type: Array,
        default:[]
      },
      yTitle:{
        type: String,
        default:''
      },
    },
    data () {
      return {
        tooltip,
        scale,
        height: 100
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "chart";
</style>